import type { Interpolation, Theme } from '@emotion/react'
import { memo } from 'react'
import SidebarIcon from '../Icons/Sidebar'
import IconButton from './IconButton'

interface IButtonSidebar {
    filled?: boolean
    onClick?(): void
    overrides?: Interpolation<Theme>
    title?: string
    size?: number
    ['data-testid']?: string
}

const ButtonSidebar = (props: IButtonSidebar) => {
    const { overrides, onClick, filled, title, size } = props
    return (
        <IconButton
            css={overrides}
            data-testid={props['data-testid']}
            onClick={onClick}
            title={title}
        >
            <SidebarIcon filled={filled} size={size} />
        </IconButton>
    )
}

export default memo(ButtonSidebar)
